module.exports = __webpack_public_path__ + "static/media/placeholder-pmc-light.49a5527a.jpg";